// Shared formatting/derivation for the Support screens (Support,
// SupportTicketPreview) — kept out of any one screen since the same ticket
// status pill is used in both the table row and the preview header.

// A ticket's Plane workflow state has no fixed vocabulary across projects, so
// "resolved" is read off `state.group` (Plane's own bucket: backlog/
// unstarted/started/completed/cancelled) when present. Before an intake item
// is triaged into a real work item it has no `state` yet — for that window
// intakeStatus (Rejected/Duplicate) is the only signal that it's already
// done.
export const isResolvedTicket = (ticket) => {
  const group = ticket?.state?.group;
  if (group) {
    return group === "completed" || group === "cancelled";
  }
  return (
    ticket?.intakeStatus === "Rejected" || ticket?.intakeStatus === "Duplicate"
  );
};

// The status pill shown on a ticket card/header. Resolved wins outright;
// otherwise "Needs your reply" only when support's message is the last word
// in the thread — a reporter who just replied is waiting on support, not the
// other way round.
export const ticketPillFor = (ticket, lastComment) => {
  if (isResolvedTicket(ticket)) {
    return {
      label: "Resolved",
      backgroundColor: "#00892F29",
      color: "#00892F"
    };
  }
  if (lastComment?.role === "support") {
    return {
      label: "Needs your reply",
      backgroundColor: "rgba(246, 201, 88, 0.12)",
      color: "rgba(181, 132, 0, 1)"
    };
  }
  return {
    label: "Open",
    backgroundColor: "rgba(46, 169, 255, 0.12)",
    color: "rgba(0, 150, 255, 1)"
  };
};

const formatTime = (ms) =>
  new Date(ms).toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true
  });

// "8 Aug, 8:05 AM" — the ticket-opened line at the top of a conversation
// (SupportTicketPreview).
export const formatOpenedAt = (iso) => {
  const date = new Date(iso);
  const day = date.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short"
  });
  return `${day}, ${formatTime(date.getTime())}`;
};
